import React, { useEffect } from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import useSWR from 'swr';
import ScreenHeader from '../components/ScreenHeader';
import { localAxios } from '../api';

const SITE_NAMES = { 1: 'Ruby Hill', 2: 'McCoy Cove', 3: 'Lone Tree', 4: 'Granite Creek' };

export default function VisitorConfirm() {
    const navigate = useNavigate();
    const location = useLocation();
    const { data: meResponse, isLoading } = useSWR('/api/me', localAxios);

    const siteId = location.state?.siteId;

    useEffect(() => {
        localAxios.post('/api/workflow-state', { step: 'visitor-confirm', site_id: siteId ?? null })
            .catch((err) => console.log('Error saving workflow state:', err));
    }, [siteId]);

    if (isLoading) return null;

    const me = meResponse?.data;
    const siteName = SITE_NAMES[siteId];
    const inviteRoles = location.state?.inviteRoles ?? { isVisitor: true };

    const roleCount = [inviteRoles.isGuardian, inviteRoles.isInviter, inviteRoles.isVisitor].filter(Boolean).length;

    const handleConfirm = () => {
        if (siteName) {
            navigate(`/acknowledge/${encodeURIComponent(siteName)}`);
        } else {
            navigate('/choose');
        }
    };

    return (
        <div className="app-wide__container">
            <ScreenHeader message="Visitor Confirmation" />
            <div className="app-wide__add-new">
                <div className="visitor-confirm__badge">
                    <span className="visitor-confirm__badge-name">
                        {me?.first_name} {me?.last_name}
                    </span>
                </div>
                <p style={{ margin: '12px 16px 0', fontSize: '15px', color: '#555' }}>
                    Please confirm your information below before continuing to the acknowledgment.
                </p>
            </div>
            <div className="app-wide__main">
                <div className="visitor-confirm__card">
                    <div className="visitor-confirm__row">
                        <span className="visitor-confirm__label">Name</span>
                        <span className="visitor-confirm__value">
                            {me?.first_name} {me?.last_name}
                        </span>
                    </div>
                    <div className="visitor-confirm__row">
                        <span className="visitor-confirm__label">Email</span>
                        <span className="visitor-confirm__value">{me?.email}</span>
                    </div>
                    {me?.phone && (
                        <div className="visitor-confirm__row">
                            <span className="visitor-confirm__label">Phone</span>
                            <span className="visitor-confirm__value">{me.phone}</span>
                        </div>
                    )}
                    {me?.organization && (
                        <div className="visitor-confirm__row">
                            <span className="visitor-confirm__label">Organization</span>
                            <span className="visitor-confirm__value">{me.organization}</span>
                        </div>
                    )}
                    {roleCount > 1 && (
                        <div className="visitor-confirm__row">
                            <span className="visitor-confirm__label">Role</span>
                            <span className="visitor-confirm__value">
                                {inviteRoles.isGuardian && <span className="visitor-tag visitor-tag--guardian">Guardian</span>}
                                {inviteRoles.isInviter  && <span className="visitor-tag visitor-tag--inviter">Inviter</span>}
                                {inviteRoles.isVisitor  && <span className="visitor-tag visitor-tag--visitor">Visitor</span>}
                            </span>
                        </div>
                    )}
                    {siteName && (
                        <div className="visitor-confirm__row">
                            <span className="visitor-confirm__label">Site</span>
                            <span className="visitor-confirm__value">{siteName}</span>
                        </div>
                    )}
                </div>
            </div>
            <div className="app-wide__footer">
                <div className="formButtons">
                    <button className="button save" onClick={handleConfirm}>
                        Confirm &amp; Continue
                    </button>
                </div>
            </div>
        </div>
    );
}
